import confetti from "canvas-confetti";

const COLORS = ["#F43F5E", "#8B5CF6", "#3B82F6", "#FCD34D", "#FFCBE6", "#FEF08A"];

export function burstConfetti() {
  const defaults = { colors: COLORS, disableForReducedMotion: true };

  confetti({
    ...defaults,
    particleCount: 160,
    spread: 90,
    startVelocity: 55,
    origin: { y: 0.6 },
  });

  // side cannons
  const end = Date.now() + 800;
  (function frame() {
    confetti({
      ...defaults,
      particleCount: 6,
      angle: 60,
      spread: 60,
      origin: { x: 0 },
    });
    confetti({
      ...defaults,
      particleCount: 6,
      angle: 120,
      spread: 60,
      origin: { x: 1 },
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export function rainConfetti() {
  const defaults = { colors: COLORS, disableForReducedMotion: true };
  const duration = 2500;
  const end = Date.now() + duration;
  (function frame() {
    confetti({
      ...defaults,
      particleCount: 4,
      startVelocity: 0,
      ticks: 200,
      gravity: 0.5,
      origin: { x: Math.random(), y: -0.1 },
      scalar: 1.2,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export function popAt(x, y) {
  confetti({
    colors: COLORS,
    disableForReducedMotion: true,
    particleCount: 45,
    spread: 70,
    startVelocity: 32,
    ticks: 120,
    origin: { x, y },
    scalar: 0.9,
  });
}
